import React, { useEffect, useState } from 'react';
import cls from '@utils/css-select';
import PageContainer from 'containers/ac-containers/page-container';
import ProfileInfo from './components/profile-info/main';
import TransactionRecord from './components/transaction-record/main';
import AcBtn from 'ac-components/ac-btn';
import styles from './styles.scss';
import logOut from 'containers/ac-containers/logout';
import { sendEvent } from '@core/track';
import { useTranslation } from 'hooks/use-translation';
import Tabs from './components/tabs/main';
import CoursesView from './components/courese/courses';
import { useHistory, useParams } from 'react-router-dom';
import generatePath from '@utils/generatePath';
import { PERSONAL } from 'constants/url';

const cx = cls(styles);

function Personal() {
	const { transData } = useTranslation('profile');
	const [activeId, setActiveId] = useState(1);

	useEffect(() => {
		sendEvent({
			eventId: 'EAF_501fd6b108a68f57',
		});
	}, []);

	const params = useParams<{ activeId: string }>();

	useEffect(() => {
		setActiveId(parseInt(params.activeId || '1'));
	}, [params]);

	const history = useHistory();
	const changeTab = (id: number) => {
		setActiveId(id);
		history.replace(generatePath(PERSONAL, { activeId: id }));
	};

	return (
		<PageContainer style={{ background: '#F4F9FE' }}>
			<div id="personal-alert-wrap"></div>
			<Tabs activeId={activeId} tabClick={(id) => changeTab(id)} />
			<div className={cx('cont-box')}>
				{activeId === 1 && <CoursesView />}
				{activeId === 2 && <ProfileInfo />}
				{activeId === 3 && <TransactionRecord />}
			</div>

			{/* <div className={cx('log-out_wrap')}>
				<AcBtn
					type='minor'
					className={cx('log-out_btn')}
					onClick={() => logOut(transData)}>
					{transData.logout}
				</AcBtn>
			</div> */}
		</PageContainer>
	);
}

export default Personal;
